module.exports = __webpack_public_path__ + "media/images/logo_dashboard@2x-eda62bb0144ca0cf193fa7c8714476c1.png";